module.exports = __webpack_public_path__ + "static/media/6.4fb9cbc2.png";